import React, { Component } from 'react';

/**
 * ### redux connection
 */
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import reducers from '../redux/reducers/Index';
import { createHashHistory } from 'history';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import AppTheme from './AppTheme';
import Router from './Router';

const hashHistory = createHashHistory();
const createStoreWithMiddleware = applyMiddleware(thunk, routerMiddleware(hashHistory))(
  createStore
);
const reducer = combineReducers(reducers);
/* eslint-disable no-underscore-dangle */
const store = createStoreWithMiddleware(
  reducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
/* eslint-enable */
const history = syncHistoryWithStore(hashHistory, store, { query_support: true });

class App extends Component {
  render () {
    return (
      <Provider store={store}>
        <MuiThemeProvider theme={AppTheme}>
          <Router history={history} />
        </MuiThemeProvider>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js